import React from 'react'
import { observer } from 'mobx-react'
import { useAnimationProgress } from 'contexts/AnimationProgressContext'
import WorkspaceSelectorViewHeading from 'components/WorkspaceSelectorViewHeading'
import Workspace from 'iam/models/Workspace'
import DocumentRootViewModel from './DocumentRootViewModel'
import { FrameValue } from 'react-spring'

interface Props {
  vm: DocumentRootViewModel
  compactionAnimationProgress?: FrameValue<number>
}

export default observer(function DocumentsViewHeading({
  vm,
  compactionAnimationProgress,
}: Props) {
  compactionAnimationProgress = useAnimationProgress(
    compactionAnimationProgress,
  )

  return (
    <WorkspaceSelectorViewHeading
      primaryText={'Documents Center'}
      allOptionText={'All Documents'}
      workspaces={vm.currentUserWorkspaces}
      dropdownTitle="View documents in"
      compactionAnimationProgress={compactionAnimationProgress}
      onChange={vm.selectWorkspaceForFiltering}
      value={
        vm.workspaceFilter.type === 'AllWorkspaces'
          ? Workspace.none
          : vm.workspaceFilter.workspace
      }
    />
  )
})
